import React from 'react';
import T from 'prop-types';
import qs from 'query-string';
import { Route, Redirect } from 'react-router-dom';

import { MODAL_LOGIN } from '../../constants/app';
import * as params from '../../constants/params';

const makeTo = (redirectTo) => {
  const search = `?${qs.stringify({
    [params.MODAL]: MODAL_LOGIN,
    [params.REDIRECT_TO]: redirectTo,
  })}`;

  return {
    pathname: '/metrics',
    search,
  };
};

const PrivateRoute = ({ component: Component, layout: Layout, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated ? (
        <Layout>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect to={makeTo(rest.location.pathname)} />
      )
    }
  />
);

PrivateRoute.propTypes = {
  isAuthenticated: T.bool.isRequired,
  component: T.oneOfType([T.node, T.func]).isRequired,
  layout: T.oneOfType([T.node, T.func]).isRequired,
};

export default PrivateRoute;
